export default "__VITE_ASSET__jrTIQQgU__"